module.exports = __webpack_public_path__ + "img/Telehealth.2097dfe6.svg";